import { createFileRoute } from "@tanstack/react-router";
import SearchHub from "@/pages/SearchHub";

export const Route = createFileRoute("/_app/search")({
  component: SearchHub,
});
